import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77d3578f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "net-salary-info-inner" }
const _hoisted_2 = { class: "salary" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Bruttolön", -1))
const _hoisted_4 = ["v-model", "value", "onKeyup"]
const _hoisted_5 = { class: "tax-rate" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Skattesats", -1))
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "dividend-info" }
const _hoisted_9 = { class: "dividends" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Utdelningsutrymme", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Förenklingsregeln", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Huvudregeln", -1))
const _hoisted_13 = { class: "wanted-dividend" }
const _hoisted_14 = {
  class: "information-text",
  for: "slider"
}
const _hoisted_15 = ["title"]
const _hoisted_16 = ["v-model", "value", "onKeyup"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = ["max"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { formatter } from "@/formatter";
import { computed, onMounted, ref } from "vue";

interface TaxRates {
  rate: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'NetSalaryInfo',
  props: {
  netProfit: {
    type: Number,
    default: 0,
  },
  informationText: {
    type: String,
    default: "Infotext",
    required: true,
  },
  dataType: {
    type: String,
    default: "",
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  maximumRange: {
    type: Number,
    default: 500000,
  },
  wantedDividend: {
    type: Number,
    default: 0,
  },
  dividendSimplifiedRule: {
    type: Number,
    default: 220671,
  },
  dividendMainRule: {
    type: Number,
    default: 0,
  },
  taxRate: {
    type: Number,
    default: 31,
  },
  salary: {
    type: Number,
    default: 53100,
  },
},
  emits: ["calculate", "taxRate", "wantedDividend", "salary"],
  setup(__props, { emit }) {

const props = __props;



const currentDividend = ref(props.wantedDividend);
const chosenTaxRate = ref(props.taxRate);
let chosenSalary = ref(props.salary);


const taxRates: TaxRates[] = [
  { rate: 29 },
  { rate: 30 },
  { rate: 31 },
  { rate: 32 },
  { rate: 33 },
  { rate: 34 },
];

function handleChange(event: any) {
  event.target.value =
    formatter.format(event.target.value) + ` ${props.dataType}`;
}

function handleSalary(event: any) {
  event.target.value
    // Add a space after every set of 4 digits
    .replace(/(.{4})/g, "$1 ")
    // Remove the space after the last set of digits
    .trim();
  emit("salary", chosenSalary.value);
}

function handleWantedDividend(event: any) {
  event.target.value
    // Add a space after every set of 4 digits
    .replace(/(.{4})/g, "$1 ")
    // Remove the space after the last set of digits
    .trim();
  emit("wantedDividend", currentDividend.value);
}

function handleKeyUp(event: any) {
  //key code for enter
  // We use this method to de-select a textfield when we press enter.
  if (event.keyCode === 13) {
    event.preventDefault();
    event.target.blur();
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("input", {
        "v-model": _unref(chosenSalary),
        value: _unref(formatter).format(_unref(chosenSalary)) + ` ${props.dataType}`,
        class: "textfield",
        pattern: "[0-9]*",
        oninput: "this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\\..*?)\\..*/g, '$1');",
        type: "text",
        onChange: handleChange,
        onKeyup: _withKeys(handleKeyUp, ["enter"]),
        onInput: handleSalary
      }, null, 40, _hoisted_4),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(chosenSalary) ? (chosenSalary).value = $event : chosenSalary = $event)),
        type: "range",
        class: "slider",
        tabindex: "-1",
        max: 100000,
        step: 100,
        min: 10000,
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('salary', _unref(chosenSalary))))
      }, null, 544), [
        [
          _vModelText,
          _unref(chosenSalary),
          void 0,
          { number: true }
        ]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((chosenTaxRate).value = $event)),
        class: "rates",
        onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('taxRate', chosenTaxRate.value)))
      }, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(taxRates, (rates) => {
          return _createElementVNode("option", {
            key: rates.rate,
            value: rates.rate
          }, _toDisplayString(_unref(formatter).format(rates.rate) + `%`), 9, _hoisted_7)
        }), 64))
      ], 544), [
        [_vModelSelect, chosenTaxRate.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("table", null, [
          _createElementVNode("tr", null, [
            _hoisted_11,
            _createElementVNode("td", null, _toDisplayString(_unref(formatter).format(__props.dividendSimplifiedRule)) + " kr", 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_12,
            _createElementVNode("td", null, _toDisplayString(_unref(formatter).format(__props.dividendMainRule)) + " kr", 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("h3", _hoisted_14, [
          _createTextVNode(_toDisplayString(__props.informationText) + " ", 1),
          _createElementVNode("i", {
            class: "fas fa-info-circle",
            title: __props.title,
            onclick: "alert('Utdelningen i den här slidern beror på summan du vill ta ut. Du kan välja allt ifrån 0 och spara utdelningen till nästa år, eller ta ut enligt förenklingsregeln eller huvudregeln. Allt beroende på vad som är mest fördelaktigt för dig i år.')"
          }, null, 8, _hoisted_15)
        ]),
        _createElementVNode("input", {
          "v-model": currentDividend.value,
          value: _unref(formatter).format(currentDividend.value) + ` ${props.dataType}`,
          type: "text",
          class: "textfield",
          pattern: "[0-9]*",
          oninput: "this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\\..*?)\\..*/g, '$1');",
          onChange: handleChange,
          onKeyup: _withKeys(handleKeyUp, ["enter"]),
          onInput: handleWantedDividend
        }, null, 40, _hoisted_16),
        _hoisted_17,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((currentDividend).value = $event)),
          type: "range",
          class: "slider",
          tabindex: "-1",
          max: __props.maximumRange,
          min: 0,
          onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('wantedDividend', currentDividend.value, __props.maximumRange)))
        }, null, 40, _hoisted_18), [
          [
            _vModelText,
            currentDividend.value,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_19
      ])
    ])
  ]))
}
}

})